/**
 * ユーザーエージェントからデバイスとブラウザの組み合わせコードを取得
 * @returns デバイスとブラウザの組み合わせコード
 * 0: その他
 * 1: PC Chrome
 * 2: PC Safari
 * 3: PC Edge
 * 4: PC その他
 * 5: iOS Chrome
 * 6: iOS Safari
 * 7: Android Chrome
 * 8: Android Safari
 * 9: モバイル その他
 */
export const detectDeviceAndBrowser = (): string => {
  const userAgent = navigator.userAgent.toLowerCase();

  // OSの判定
  const isIOS = /iphone|ipad|ipod/.test(userAgent);
  const isAndroid = /android/.test(userAgent);
  const isMobile = /iphone|ipad|ipod|android|mobile/.test(userAgent);

  // ブラウザの判定
  const isChrome = /chrome|crios/.test(userAgent) && !/edge|edg/.test(userAgent);
  const isSafari = /safari/.test(userAgent) && !/chrome|crios/.test(userAgent);
  const isEdge = /edge|edg/.test(userAgent);

  // デバイス・ブラウザの組み合わせコードを決定
  if (isMobile) {
    if (isIOS) {
      if (isChrome) return 'IOS_CHROME';
      else if (isSafari) return 'IOS_SAFARI';
      else return 'MOBILE_OTHER';
    } else if (isAndroid) {
      if (isChrome) return 'ANDROID_CHROME';
      else if (isSafari) return 'ANDROID_SAFARI';
      else return 'MOBILE_OTHER';
    } else {
      return 'MOBILE_OTHER';
    }
  } else {
    // PCの場合
    if (isChrome) return 'PC_CHROME';
    else if (isSafari) return 'PC_SAFARI';
    else if (isEdge) return 'PC_EDGE';
    else return 'PC_OTHER';
  }
};

/**
 * デバイスとブラウザの組み合わせコードを取得するカスタムフック
 * @returns デバイスとブラウザの組み合わせコード
 */
// export const useDeviceDetection = (): number => {
//   const [deviceBrowserCode, setDeviceBrowserCode] = useState<number>(OTHER);

//   useEffect(() => {
//     setDeviceBrowserCode(detectDeviceAndBrowser());
//   }, []);

//   return deviceBrowserCode;
// };
